﻿import {GameManager} from "../../Game/GameManager";
import {Core} from "../../Base/Core";
import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {UIButton} from "../Tools/Base/UIButton";
import {UIText} from "../Tools/Base/UIText";
import {Utils} from "../../Utils/Utils";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UISprite} from "../Tools/Base/UISprite";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";

const VIP_PRODUCT_ID = "vip";

class Badge extends UISprite {
    Awake() {
        super.Awake();
        this.circle = this.addChild(new UISprite("offers/vip-badge-bg"));
        this.crown = this.addChild(new UISprite("offers/crown"));
        this.vipText = this.addChild(new UIText(Core.Localizator.Get("vip")));

        this.ribbon = this.addChild(new UISprite("offers/ribbon"));
        this.ribbonText = this.addChild(new UIText(Core.Localizator.Get("gold_membership")));
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);

        let topRect = rect.clone();
        topRect.width = rect.width * 0.5;
        topRect.height = rect.height * 0.77;
        topRect.x = (rect.width - topRect.width) * 0.5;
        topRect.y = (rect.height - topRect.height) * 0;
        this.circle.fitRect(topRect);

        topRect = rect.clone();
        topRect.width = rect.width * 0.4;
        topRect.height = rect.height * 0.3;
        topRect.x = (rect.width - topRect.width) * 0.5;
        topRect.y = (rect.height - topRect.height) * 0.2;
        this.crown.fitRect(topRect);

        topRect.width = this.circle.width * 0.6;
        topRect.height = this.circle.height * 0.3;
        topRect.x = (rect.width - topRect.width) * 0.5;
        topRect.y = this.crown.y + this.crown.height * 0.45;
        this.vipText.fitLayout(topRect);

        let bottomRect = rect.clone();
        bottomRect.width = rect.width;
        bottomRect.height = rect.height * 0.35;
        bottomRect.x = 0;
        bottomRect.y = (rect.height - bottomRect.height) * 1;
        this.ribbon.fitRect(bottomRect);

        bottomRect.height = this.ribbon.height * 0.8;
        bottomRect.width = this.ribbon.width * 0.75;
        bottomRect.x = (rect.width - bottomRect.width) * 0.5;
        bottomRect.y = this.ribbon.y - this.ribbon.height * 0.5;
        this.ribbonText.fitLayout(bottomRect);
    }
}

class BonusField extends UISprite {
    constructor() {
        super();

        this.firstBonusField = this.createField();
        this.secondBonusField = this.createField({ icon: "ico-gold", iconAlign: "right", iconSize: 1.1 });
        this.thirdBonusField = this.createField({ icon: "ico-diamond", iconAlign: "right", iconSize: 1.1 });
        this.fourthBonusField = this.createField({ icon: "ico-diamond", iconAlign: "right", iconSize: 1.1 });
    }

    createField(props) {
        let field = this.addChild(new UISprite());
        field.box = field.addChild(new UISprite("box"));
        field.text = field.addChild(new UILabeledIcon(props));
        return field;
    }

    Init() {
        super.Init();
        let hardBonus = ~~(Core.GameData.AppStore.vip.hardMoneyBonus * 100 - 100);
        this.firstBonusField.text.label = Core.Localizator.Get("vip_bonus_ads");
        this.secondBonusField.text.label = "x2";
        this.thirdBonusField.text.label = Core.Localizator.Get("vip_hard_bonus", hardBonus);
        this.fourthBonusField.text.label =
            Core.Localizator.Get("every_day") + " " + Utils.Format("+{0}", Core.GameData.AppStore.vip.hardMoneyDailyBonus);
    }

    fitChild(child, rect) {
        child.position.copyFrom(rect);

        let boxRect = rect.clone();
        boxRect.width = rect.width * 0.1;
        boxRect.height = rect.height;
        boxRect.x = 0;
        boxRect.y = 0;
        child.box.fitRect(boxRect);

        let txtRect = rect.clone();
        txtRect.width = rect.width * 0.88;
        txtRect.height = rect.height;
        txtRect.x = rect.width * 0.12;
        txtRect.y = 0;
        child.text.fitLayout(txtRect);
    }

    fitLayout(rect) {
        let newRect = rect.clone();
        newRect.width = rect.width;
        newRect.height = rect.height * 0.2;
        newRect.x = rect.x + (rect.width - newRect.width) * 0;
        newRect.y = rect.y;
        this.fitChild(this.firstBonusField, newRect);

        newRect.y += rect.height * 0.265;
        this.fitChild(this.secondBonusField, newRect);

        newRect.y += rect.height * 0.265;
        this.fitChild(this.thirdBonusField, newRect);

        newRect.y += rect.height * 0.265;
        this.fitChild(this.fourthBonusField, newRect);
    }
}

class Creatures extends UISprite {
    Awake() {
        super.Awake();

        this.leftCreature = this.addChild(new UISprite("creatures/1"));
        this.centerCreature = this.addChild(new UISprite("creatures/4"));
        this.rightCreature = this.addChild(new UISprite("creatures/12"));

        this.crown = this.addChild(new UISprite("offers/crown"));

        this.leftCreature.anchor.y = 1;
        this.leftCreature.rotation = -0.2;
        this.centerCreature.anchor.y = 1;
        this.rightCreature.anchor.y = 1;
        this.rightCreature.rotation = 0.2;
    }

    fitLayout(rect) {
        let imgRect = rect.clone();
        imgRect.width = rect.width * 0.33;
        imgRect.height = rect.height * 0.6;
        imgRect.x = rect.x + (rect.width - imgRect.width) * 0;
        imgRect.y = rect.y + (rect.height - imgRect.height) * 1;
        this.leftCreature.fitRect(imgRect);

        imgRect = rect.clone();
        imgRect.width = rect.width * 0.4;
        imgRect.height = rect.height * 0.75;
        imgRect.x = rect.x + (rect.width - imgRect.width) * 0.5;
        imgRect.y = rect.y + (rect.height - imgRect.height) * 0.9;
        this.centerCreature.fitRect(imgRect);

        imgRect.width = rect.width * 0.25;
        imgRect.height = rect.width * 0.25;
        imgRect.x = this.centerCreature.x - imgRect.width * 0.5;
        imgRect.y = this.centerCreature.y - this.centerCreature.height - imgRect.height * 0.7;
        this.crown.fitRect(imgRect);

        imgRect = rect.clone();
        imgRect.width = rect.width * 0.33;
        imgRect.height = rect.height * 0.6;
        imgRect.x = rect.x + (rect.width - imgRect.width) * 1;
        imgRect.y = rect.y + (rect.height - imgRect.height) * 1;
        this.rightCreature.fitRect(imgRect);
    }
}

export class UIVip extends UICommonPopup {
    get lastShowPopupTime() {
        return PlayerPrefs.GetInt("vippopup", 0);
    }

    set lastShowPopupTime(value) {
        PlayerPrefs.SetInt("vippopup", value);
    }

    Awake() {
        super.Awake({ skin: "magenta", closeButton: true });

        this.badge = this.content.addChild(new Badge());
        this.bonusField = this.content.addChild(new BonusField());
        this.creatures = this.content.addChild(new Creatures());

        this.btn = this.content.addChild(new UINineSliceButton("offers/btn-orange-big"));

        this.bottomTextField = this.content.addChild(new UIText()); // Text bottomTextField;
        this.termsLinkBtn = this.content.addChild(new UIButton()); // Button termsLinkBtn;

        this.btn.on("pointertap", () => Core.Store.BuyProductID(VIP_PRODUCT_ID));
    }

    Init() {
        super.Init();

        this.onProductPurchased = this.onProductPurchased.bind(this);
        Core.Store.on("Purchased", this.onProductPurchased);

        this.bonusField.Init();

        this.termsLinkBtn.on("pointertap", () => {
            // Application.OpenURL("https://www.aigames.ae/policy");
        });
    }

    fitLayout(viewport = Core.app.viewport) {
        this.setPopupSize(viewport.width, viewport.height);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.75;
        rect.height = contentRect.height * 0.18;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.05;
        this.badge.fitLayout(rect);

        const width = this.badge.ribbon.width;

        rect = contentRect.clone();
        rect.width = width * 0.8;
        rect.height = contentRect.height * 0.14;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.3;
        this.bonusField.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = width;
        rect.height = contentRect.height * 0.2;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.52;
        this.creatures.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = width * 1.2;
        rect.height = contentRect.height * 0.11;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.69;
        this.btn.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = width * 1.2;
        rect.height = contentRect.height * 0.21;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.bottomTextField.fitLayout(rect);
    }

    ShowAgressive() {
        if (!Core.Store.IsInitialized) return;
        if (Core.Store.VipActive) return;
        if (GameManager.tutorialState != 0) return;

        let timeFromLast = (Date.now() - this.lastShowPopupTime) / 1000;
        if (timeFromLast >= 3600 * 24) {
            this.Show();
        }
    }

    Show() {
        return;  // XXX: VIP temporary off

        super.Show();

        let vipProduct = Core.GameData.GetAppStoreProductById("vip");
        let price = Core.Store.GetPrice(vipProduct.PlatformStoreId);
        let priceNumber = Core.Store.GetPriceNumber(vipProduct.PlatformStoreId);

        this.btn.label = Core.Localizator.Get("vip_price", 3, price);

        this.bottomTextField.text = Core.Localizator.Get("vip_small_text", price, Core.Localizator.Get("vip_google_account"));
        this.bottomTextField.text = Core.Localizator.Get("vip_small_text", price, Core.Localizator.Get("vip_itunes_account"));

        this.lastShowPopupTime = Date.now();
        Core.Analytics.SendOfferEvent("vip", priceNumber, "vip", 0, 0, "show");
    }

    onProductPurchased(product) {
        if (product.id == VIP_PRODUCT_ID) {
            this.Hide();
        }
    }
}
